import { render, staticRenderFns } from "./PeopleQuotaInfo.vue?vue&type=template&id=7a7e03a6&scoped=true&"
import script from "./PeopleQuotaInfo.vue?vue&type=script&lang=js&"
export * from "./PeopleQuotaInfo.vue?vue&type=script&lang=js&"
import style0 from "./PeopleQuotaInfo.vue?vue&type=style&index=0&id=7a7e03a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7e03a6",
  null
  
)

export default component.exports